import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import classNames from "classnames";

import { styles as spotlightStyles } from "../../utils/spotlight";

@customElement("bp-ephesians-literary-design")
export class EphesiansLiteraryDesign extends LitElement {
  static styles = [
    spotlightStyles,
    css`
      :host {
        display: block;
        white-space: nowrap;
        --group-body-font-size: 16px;
        --group-title-font-size: 14px;
        --title-font-size: 22px;
        --reference-font-size: 18px;
      }

      .design {
        overflow-x: auto;
        padding-bottom: var(--size-1);
      }

      .title {
        font-size: var(--title-font-size);
        font-weight: var(--font-weight-normal);
        line-height: var(--line-height-snug);
      }

      .reference {
        font-size: var(--reference-font-size);
        font-weight: var(--font-weight-bold);
        margin-bottom: var(--size-3);
      }

      .group-title {
        font-size: var(--group-title-font-size);
        font-weight: var(--font-weight-semibold);
        margin: var(--size-3) 0 var(--size-1);
      }

      .group-title[data-id="group-title-1"] {
        margin-top: 0;
      }

      .group {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        font-size: var(--group-body-font-size);
        white-space: nowrap;
        position: relative;
        color: var(--color-black);
        transition: color var(--spotlight-transition-duration);
      }

      .arrow-bottom {
        background-color: var(--color-neutral-10);
        position: absolute;
        left: calc(var(--size-1) + 2px);
        top: var(--size-1);
        bottom: var(--size-0-5);
        width: 4px;
      }

      .arrow-top {
        position: absolute;
        left: var(--size-0-5);
        top: var(--size-0-5);
        bottom: var(--size-0-5);
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid var(--color-neutral-10);
      }

      .group:not(:has(.group)) {
        display: inline-block;
      }

      .group-debug-label {
        display: none;
      }
      .debug .group:hover {
        outline: 2px solid lightgrey;
      }
      .debug > .group:hover {
        outline: 2px solid white;
      }
      .debug .group:not(:has(.group:hover)):hover {
        outline: 2px solid red;
      }

      .debug .group:hover > .group-debug-label {
        font-size: 12px;
        font-weight: 700;
        z-index: 10;
        background-color: grey;
        color: white;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        padding: 2px;
      }
      .debug .group:not(:has(.group)):hover > .group-debug-label {
        left: calc(100% + 4px);
      }
      .debug .group:not(:has(.group:hover)):hover > .group-debug-label {
        background-color: red;
      }

      .group[indent="1"] {
        margin-inline-start: 10px;
      }
      .group[indent="2"] {
        margin-inline-start: 20px;
      }
      .group[indent="3"] {
        margin-inline-start: 30px;
      }
      .group[indent="4"] {
        margin-inline-start: 40px;
      }
      .group[indent="5"] {
        margin-inline-start: 50px;
      }
      .group[indent="6"] {
        margin-inline-start: 60px;
      }
      .group[indent="7"] {
        margin-inline-start: 70px;
      }
      .group[indent="8"] {
        margin-inline-start: 80px;
      }
      .group[indent="9"] {
        margin-inline-start: 90px;
      }
      .group[indent="10"] {
        margin-inline-start: 100px;
      }
      .group[indent="11"] {
        margin-inline-start: 110px;
      }
      .group[indent="12"] {
        margin-inline-start: 120px;
      }
      .group[indent="13"] {
        margin-inline-start: 130px;
      }
      .group[indent="14"] {
        margin-inline-start: 140px;
      }
      .group[indent="15"] {
        margin-inline-start: 150px;
      }
      .group[indent="16"] {
        margin-inline-start: 160px;
      }
      .group[indent="17"] {
        margin-inline-start: 170px;
      }
      .group[indent="18"] {
        margin-inline-start: 180px;
      }
      .group[indent="19"] {
        margin-inline-start: 190px;
      }
      .group[indent="20"] {
        margin-inline-start: 200px;
      }
      .group[indent="21"] {
        margin-inline-start: 210px;
      }
      .group[indent="22"] {
        margin-inline-start: 220px;
      }
      .group[indent="23"] {
        margin-inline-start: 230px;
      }
      .group[indent="24"] {
        margin-inline-start: 240px;
      }
      .group[indent="25"] {
        margin-inline-start: 250px;
      }
      .group[indent="26"] {
        margin-inline-start: 260px;
      }
      .group[indent="27"] {
        margin-inline-start: 270px;
      }
      .group[indent="28"] {
        margin-inline-start: 280px;
      }
      .group[indent="29"] {
        margin-inline-start: 290px;
      }
      .group[indent="30"] {
        margin-inline-start: 300px;
      }
      .group[indent="31"] {
        margin-inline-start: 310px;
      }
      .group[indent="32"] {
        margin-inline-start: 320px;
      }
      .group[indent="33"] {
        margin-inline-start: 330px;
      }
      .group[indent="34"] {
        margin-inline-start: 340px;
      }
      .group[indent="35"] {
        margin-inline-start: 350px;
      }
      .group[indent="36"] {
        margin-inline-start: 360px;
      }
      .group[indent="37"] {
        margin-inline-start: 370px;
      }
      .group[indent="38"] {
        margin-inline-start: 380px;
      }
      .group[indent="39"] {
        margin-inline-start: 390px;
      }
      .group[indent="40"] {
        margin-inline-start: 400px;
      }
      .group[indent="41"] {
        margin-inline-start: 410px;
      }
      .group[indent="42"] {
        margin-inline-start: 420px;
      }
      .group[indent="43"] {
        margin-inline-start: 430px;
      }
      .group[indent="44"] {
        margin-inline-start: 440px;
      }
      .group[indent="45"] {
        margin-inline-start: 450px;
      }
      .group[indent="46"] {
        margin-inline-start: 460px;
      }
      .group[indent="47"] {
        margin-inline-start: 470px;
      }
      .group[indent="48"] {
        margin-inline-start: 480px;
      }
      .group[indent="49"] {
        margin-inline-start: 490px;
      }
      .group[indent="50"] {
        margin-inline-start: 500px;
      }
    `,
  ];

  @property()
  reference: string | undefined;

  @property({ attribute: "title" })
  designTitle?: string;

  @property({ attribute: "data" })
  data?: string;

  @property({ type: Boolean, attribute: "debug" })
  debug?: boolean;

  annotateTags(tagName: string, html: string) {
    let count = 1;
    const regexp = new RegExp(`<([^>]*)class="${tagName}"([^>]*)>`, "g");
    return html.replace(regexp, (_match, p1, p2) => {
      let value = `<${p1}class="${tagName}" data-id="${tagName}-${count}"${p2}>`;
      if (this.debug) {
        value += `<div class="group-debug-label">Id: ${tagName}-${count}</div>`;
      }
      count += 1;
      return value;
    });
  }

  get annotatedHtml() {
    let result = this.data ?? "";
    result = this.annotateTags("group", result);
    result = this.annotateTags("group-title", result);
    result = result?.replace("<bp-mark", "<bp-mark can-spotlight ");
    return result;
  }

  render() {
    if (!this.data) return;
    const classes = classNames({ debug: this.debug });
    return html`<div class="${classes}">
      ${this.designTitle
        ? html`<div class="title">${this.designTitle}</div>`
        : null}
      ${this.reference
        ? html`<div class="reference">${this.reference}</div>`
        : null}
      <div class="design">${unsafeHTML(this.annotatedHtml)}</div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-ephesians-literary-design": EphesiansLiteraryDesign;
  }
}
